export default __webpack_public_path__ + "static/media/operatory_4.299b88ae.png";